import { Children, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Keyboard, Mousewheel } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import { prefersReducedMotion } from 'components/BinanceLanding/landingHelpers';
import arrowLeft from 'assets/icons/home/hmArrowLeft.svg';
import arrowRight from 'assets/icons/home/hmArrowRight.svg';
import classes from './HomeSlider.module.scss';


// Лента карточек со стрелками в шапке — как в макете. Работает на Swiper:
// тянется мышью и пальцем, листается тачпадом и стрелками клавиатуры.
// loop — бесконечная лента по кругу; без него лента свободная, с инерцией,
// а стрелки на краях перескакивают в начало или конец.
// Ширину слайда задаёт slideClass (например, 3 / 2 / 1 карточки в ряд)
// или slidesPerView в breakpoints.
const DEFAULT_BREAKPOINTS = {
  0: { spaceBetween: 12 },
  835: { spaceBetween: 20 },
};

const HomeSlider = ({
  title,
  subtitle,
  action,
  children,
  trackClass = '',
  loop = false,
  slideClass = '',
  breakpoints = DEFAULT_BREAKPOINTS,
}) => {
  const swiperRef = useRef(null);
  const slides = Children.toArray(children).filter(Boolean);
  const reducedMotion = prefersReducedMotion();

  const go = (direction) => {
    if (direction > 0) swiperRef.current?.slideNext();
    else swiperRef.current?.slidePrev();
  };

  return (
    <>
      <div className={classes.head} data-aos="fade-up">
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.arrows}>
          <button
            type="button"
            className={classes.arrow}
            onClick={() => go(-1)}
            aria-label="Назад"
          >
            <img src={arrowLeft} alt="" />
          </button>
          <button
            type="button"
            className={classes.arrow}
            onClick={() => go(1)}
            aria-label="Вперёд"
          >
            <img src={arrowRight} alt="" />
          </button>
        </div>
      </div>

      {subtitle && <p className={classes.subtitle} data-aos="fade-up">{subtitle}</p>}
      {action && <div className={classes.action} data-aos="fade-up">{action}</div>}

      <Swiper
        className={`${classes.swiper} ${trackClass}`}
        modules={[ FreeMode, Keyboard, Mousewheel ]}
        onSwiper={(instance) => {
          swiperRef.current = instance;
        }}
        slidesPerView="auto"
        spaceBetween={20}
        speed={reducedMotion ? 0 : 600}
        grabCursor
        keyboard={{ enabled: true, onlyInViewport: true }}
        // Горизонтальная прокрутка тачпадом; вертикальное колесо листает страницу.
        mousewheel={{ forceToAxis: true }}
        breakpoints={breakpoints}
        {...(loop
          ? { loop: true, loopedSlides: slides.length }
          : {
            rewind: true,
            freeMode: { enabled: true, momentumRatio: 0.6, momentumVelocityRatio: 0.8 },
          })}
      >
        {slides.map((child, i) => (
          // Свой класс слайда задаёт ширину сам; иначе слайд по ширине карточки.
          // Общий класс не смешиваем со своим: при равной специфичности
          // побеждал бы тот, чьи стили попали в сборку позже.
          <SwiperSlide className={slideClass || classes.slideAuto} key={child.key ?? i}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default HomeSlider;
